import Sidebar from '../../components/Sidebar';
import { Header } from '../../components/header';
import { MyClientPageSection } from '../../components/my-client-section.component';
import { useState } from 'react';
// import { useMediaQuery } from '@mui/material';


const MyClientPage = ({
}) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    return (
        <div className="dashboard-page">
            <div className="dashboard-layout">
                <Sidebar
                    activeItemId='clients'
                    footer={null}
                    onClose={() => setIsSidebarOpen(false)}
                    className={`dashboard-sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}
                />
                {isSidebarOpen && (
                    <div
                        className="sidebar-overlay"
                        onClick={() => setIsSidebarOpen(false)}
                    />
                )}

                <div className="dashboard-main-content ">
                    <Header
                    setIsSidebarOpen={setIsSidebarOpen}
                    />
                    <div className='px-3 py-3'>
                        <MyClientPageSection
                            className="invoices-section"
                        />
                    </div>

                </div>
            </div>
        </div>
    );
}

export default MyClientPage;